import { useCallback, useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { flushSalesQueue, getQueueCount, QUEUE_CHANGED_EVENT } from '@/lib/offline-queue';

/**
 * Oflayn holat va sotuv navbati hisobini kuzatadi.
 * Internet qaytganda (yoki POS sahifasi ochilganda) navbatni avtomatik yuboradi.
 */
export function useOfflineQueue() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [queuedCount, setQueuedCount] = useState(0);
  const queryClient = useQueryClient();

  const refresh = useCallback(async () => {
    try {
      setQueuedCount(await getQueueCount());
    } catch {
      // IndexedDB mavjud emas — e'tiborsiz
    }
  }, []);

  useEffect(() => {
    const invalidateAfterFlush = (sent: number) => {
      if (sent > 0) {
        queryClient.invalidateQueries({ queryKey: ['sales'] });
        queryClient.invalidateQueries({ queryKey: ['stocks'] });
        queryClient.invalidateQueries({ queryKey: ['customers'] });
      }
    };

    const goOnline = () => {
      setIsOnline(true);
      flushSalesQueue().then(({ sent }) => invalidateAfterFlush(sent));
    };
    const goOffline = () => setIsOnline(false);
    const onQueueChanged = () => {
      refresh();
    };

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    window.addEventListener(QUEUE_CHANGED_EVENT, onQueueChanged);
    refresh();

    if (navigator.onLine) {
      flushSalesQueue().then(({ sent }) => invalidateAfterFlush(sent));
    }

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
      window.removeEventListener(QUEUE_CHANGED_EVENT, onQueueChanged);
    };
  }, [refresh, queryClient]);

  return { isOnline, queuedCount, refresh };
}
